import $ from 'jquery';
import _ from 'lodash';
import { fetchCards } from '~loader/loader-api';
import { setServizio } from './setServizio';
import { getState, modifyState } from '~src/state';
import formatDistance from 'date-fns/formatDistance';
import it from 'date-fns/locale/it';
import { getStatePure } from '../../state';

export const initDatatableServizi = async () => {
  if (!window.editorLoader.datatableServiziInitialised) {
    const cards = await fetchCards();
    const sortedCards = _.orderBy(cards, 'createdAt', 'desc');

    $('#editorSpinnerServizio').remove();

    const table = $('#editorChooseCard').DataTable({
      data: sortedCards,
      info: false,
      order: false,
      language: {
        search: '_INPUT_',
        lengthMenu: '_MENU_',
        zeroRecords: 'Non ci sono elementi da mostrare',
        emptyTable: 'Non ci sono elementi da mostrare',
        searchPlaceholder: 'Cerca una card',
        paginate: {
          first: 'Prima',
          previous: 'Precedente',
          next: 'Prossima',
          last: 'Ultima',
          info: 'Mostro da _START_ a _END_ di _TOTAL_ valori',
        },
      },
      lengthMenu: [
        [5, 10, 50, -1],
        [5, 10, 50, 'Tutti'],
      ],
      displayLength: 5,
      pageLength: 5,
      columns: [
        { data: 'firstName', title: 'Nome' },
        { data: 'lastName', title: 'Cognome' },
        { data: 'companyName', title: 'Impresa' },
        {
          data: 'createdAt',
          title: 'Creata',
          render: function (data) {
            return formatDistance(new Date(data), new Date(), {
              addSuffix: false,
              locale: it,
            });
          },
        },
      ],
    });

    $(table.table().container()).removeClass('form-inline');

    $('#editorChooseCard tbody').on('click', 'tr', async function () {
      const data = table.row(this).data();

      const selectedCard = getStatePure('cards').find((card) => {
        if (card.id === data.id) {
          return card;
        }
      });

      setServizio(selectedCard, true);

      const cards = getState('cards', []);
      const card = cards.find((card) => {
        if (card.slug === data[2]) {
          return card;
        }
      });
      modifyState('card', card);

      setTimeout(() => {
        $('#modalEditorServizio').modal('hide');
        $('.modal-backdrop').remove();
      }, 200);
    });

    window.editorLoader.datatableServiziInitialised = true;
  }
};
